(() => {
 const initialize = () => {
  const root = document.querySelector('.nd-home');
  if (!root || root.dataset.motionInitialized === 'true') return;

  root.dataset.motionInitialized = 'true';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggle = root.querySelector('.nd-motion-toggle');
  const studio = root.querySelector('[data-nd-studio]');
  if (studio) {
    const tabs = [...studio.querySelectorAll('[data-nd-studio-tab]')];
    const panels = [...studio.querySelectorAll('[data-nd-studio-panel]')];
    const caption = studio.querySelector('[data-nd-studio-caption]');
    const note = studio.querySelector('[data-nd-studio-note]');
    const hint = studio.querySelector('[data-nd-studio-hint]');
    const selectTab = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
        panels[i].classList.toggle('is-active', selected);
      });
      caption.textContent = tabs[index].dataset.caption;
      if (note) note.textContent = tabs[index].dataset.note;
      if (hint) hint.hidden = !panels[index].querySelector('img');
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(index));
      tab.addEventListener('keydown', (event) => {
        const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
        if (direction) {
          event.preventDefault();
          selectTab((index + direction + tabs.length) % tabs.length, true);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          selectTab(event.key === 'Home' ? 0 : tabs.length - 1, true);
        }
      });
    });
  }
  root.classList.add('nd-loop-active');
  let userPaused = false;
  let offscreen = false;
  const syncMotion = () => {
    const paused = userPaused || preference.matches || document.hidden || offscreen;
    root.classList.toggle('nd-motion-paused', paused);
    if (toggle) {
      toggle.hidden = preference.matches;
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.textContent = userPaused ? 'Resume animations' : 'Pause animations';
    }
    if (preference.matches) root.classList.remove('nd-motion-ready');
  };
  toggle?.addEventListener('click', () => { userPaused = !userPaused; syncMotion(); });
  preference.addEventListener('change', syncMotion);
  document.addEventListener('visibilitychange', syncMotion);
  syncMotion();
  if (!('IntersectionObserver' in window)) return;
  const heroObserver = new IntersectionObserver(([entry]) => {
    offscreen = !entry.isIntersecting;
    syncMotion();
  });
  heroObserver.observe(root.querySelector('.nd-hero'));
  if (preference.matches) return;

  root.classList.add('nd-motion-ready');
  const revealItems = root.querySelectorAll('[data-nd-reveal]');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nd-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
  );
  revealItems.forEach((item) => observer.observe(item));

 };
 initialize();
 document.addEventListener('shopify:section:load', initialize);
})();
